import { render } from "./EditModal.vue?vue&type=template&id=3bb39c86&scoped=true&ts=true"
import script from "./EditModal.vue?vue&type=script&lang=ts"
export * from "./EditModal.vue?vue&type=script&lang=ts"

import "./EditModal.vue?vue&type=style&index=0&id=3bb39c86&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb39c86"]])

export default __exports__